module.exports = __webpack_public_path__ + "static/media/detail19.6cbd09ab.jpg";